import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, eur } from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    if (!sessionId) {
      setState({ loading: false, error: "Aucun identifiant de session." });
      return;
    }
    let cancelled = false;
    let attempts = 0;

    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setState({ loading: false, ok: true, data });
          return;
        }
        attempts += 1;
        if (attempts > 25) {
          setState({ loading: false, pending: true, data });
          return;
        }
        setTimeout(poll, 2000);
      } catch (e) {
        setState({ loading: false, error: e?.response?.data?.detail || "Erreur" });
      }
    };
    poll();
    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="payment-success-page">
      <Header />
      <div className="pt-40 pb-20 max-w-3xl mx-auto px-6 lg:px-10 text-center">
        {state.loading ? (
          <div className="flex flex-col items-center gap-4 text-gray-300">
            <Loader2 className="animate-spin gold" size={40} />
            <div className="text-lg">Confirmation du paiement...</div>
          </div>
        ) : state.ok ? (
          <div>
            <CheckCircle2 className="mx-auto gold" size={64} />
            <h1 className="mt-6 font-serif text-white text-4xl sm:text-5xl">Paiement confirmé</h1>
            <p className="mt-3 text-gray-400">
              Merci ! Votre réservation est enregistrée sous la référence
            </p>
            <div className="mt-6 inline-block border border-[color:var(--gold)] gold px-8 py-3 tracking-[0.35em] text-lg" data-testid="success-reference">
              {state.data?.reference}
            </div>
            <p className="mt-6 text-sm text-gray-500 max-w-lg mx-auto">
              Elle est désormais en attente de validation manuelle par notre équipe.
              Vous recevrez un email dès qu'elle sera confirmée.
            </p>
            <div className="mt-10 flex flex-wrap gap-4 justify-center">
              <Link
                to={`/suivi/${state.data?.reference}`}
                data-testid="btn-track-booking"
                className="btn-gold"
              >
                Suivre ma réservation
              </Link>
              <Link to="/" className="btn-outline-gold">Retour à l'accueil</Link>
            </div>
          </div>
        ) : state.pending ? (
          <div>
            <h1 className="font-serif text-white text-3xl">Paiement en cours de vérification</h1>
            <p className="mt-3 text-gray-400">
              Ce délai est parfois nécessaire. Vous pouvez fermer cette page,
              vous recevrez un email de confirmation.
            </p>
          </div>
        ) : (
          <div>
            <h1 className="font-serif text-white text-3xl">Un problème est survenu</h1>
            <p className="mt-3 text-gray-400">{state.error}</p>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
